import * as React from 'react';
import { observer } from 'mobx-react';
import { Button, FormItem, Modal, notification, NotificationType, TextArea } from '@iba-team/portal-react-components/dist';
import { InputNumber } from '../../../../utils_components/InputNumber';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DaysAvailableNamespace } from '../types';
import { DaysAvailableStore } from '../../../../store/DaysAvailable';
import {ReactComponent as RightArrowIcon} from '@iba-team/portal-react-components/dist/svg/outline/chevron-right.svg';

export const CompensatoryOffModal = observer((props: DaysAvailableNamespace.CompensatoryOffCallModalProps) => {
  const [isViewExample, toggleViewExample] = useState(false);
  const { profileRemainingDays, fetchEditCompensatoryOff ,setCompensatoryOff} = DaysAvailableStore;
  const {t} = useTranslation();
  const [isLoading, setLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [reason, setReason] = useState('');

  useEffect(() => {
    setValue(profileRemainingDays.compensatoryOffBalance);
  }, [profileRemainingDays.compensatoryOffBalance]);

  const editCompensatoryOff = ()=> {
    setLoading(true);
    fetchEditCompensatoryOff({
      balanceValue: value,
      employeeId: props.userId,
      comment: reason.length > 0 ? reason : undefined})
      .then((response)=> {
        if(response) {
          notification.open({
            type: NotificationType.SUCCESS,
            title: t('notifications.success'),
            description: t('availableDays.successEditCompensatoryOffModal')
          });
          setCompensatoryOff(value);
          props.onClose();
        } else {
          notification.open({
            type: NotificationType.ERROR,
            title:  t('notifications.error'),
            description: t('notifications.baseErrorDescription')
          });
        }
      }).finally(()=>{
        setLoading(false);
      });
  };

  const footer = [
    <Button theme={{variant: 'neutral', color: 'grey'}}
      onClick={()=> {
        setValue(profileRemainingDays.compensatoryOffBalance);
        props.onClose();
      }}>
      { t('cancel') }
    </Button>,
    <Button
      loadingState={{placement: 'left', loading: isLoading}}
      theme={{variant: 'primary', color: 'theme'}}
      onClick={editCompensatoryOff}
      disabled={(value === profileRemainingDays.compensatoryOffBalance) || isLoading}
    >
      { t('availableDays.chooseCompensatoryOffModal.setBtn') }
    </Button>,
  ];

  return (
    <Modal visible={true}
      className={'compensatoryModal'}
      footer={footer}
      onClose={()=>{
        setValue(profileRemainingDays.compensatoryOffBalance);
        toggleViewExample(false);
        props.onClose();
      }}
      titleText={t('compensatoryOff')}>
      <div className='days-available__compensatoryOffModal'>
        <div className='info'>
          <span>{t('availableDays.chooseCompensatoryOffModal.content')}</span>
          <div onClick={()=> toggleViewExample(!isViewExample)} className={isViewExample ? 'info_swapper-hide' : 'info_swapper-show'}>Example <RightArrowIcon /></div>
          {isViewExample && <div className='info_example'>{t('availableDays.chooseCompensatoryOffModal.example')}</div>}
        </div>
        <FormItem label={t('workingDays')}>
          <InputNumber
            placeholder={'0'}
            min={0}
            value={value}
            onChange={(e)=> {
              setValue(e);
            }}
          />
        </FormItem>
        <FormItem label={t('availableDays.chooseCompensatoryOffModal.reasonLabel')}>
          <TextArea
            onChange={(e) => setReason(e.target.value)}
            placeholder={t('availableDays.chooseCompensatoryOffModal.reasonPlaceholder')} />
          <p className={'reasonText'}>
            {t('availableDays.chooseCompensatoryOffModal.reasonDescription')}
          </p>
        </FormItem>
      </div>
    </Modal>
  );
});